/* eslint-disable  */
const production = (typeof process === 'undefined' || process.env.NODE_ENV === 'production');

const win: any = window;
const { __mi9__: buildData } = win;
export const baseApiUrl = production ? win.baseApiUrl : process.env.REACT_APP_CURBSIDE_API_URL;
const baseUrl = production ? win.baseUrl : process.env.REACT_APP_BASE_URL;
const brokerGatewayURL = production ? win.brokerGatewayURL : process.env.BROKER_GATEWAY_BASE_URL;
const chainSettingId = production ? win.chainSettingId : process.env.REACT_APP_CHAINSETTINGID;

export const config = {
  apiEndpoints: {
        api: `${baseApiUrl}/api`
  },
  baseUrl,
  chainSettingId,
  buildNumber: buildData?.buildNumber,
  brokerGatewayURL
};

export default config;
